const featureToggle = {
  CSS_CHART: false,
  ELO_PE: true,
  ELO_CO: true,
  ELO_CL: true,
  ELO_BR: false,
}

export const isToggleActive = flag => {
  let flagOnLocalStorage = ""

  if (typeof window !== 'undefined') {
    flagOnLocalStorage = localStorage.getItem(flag)
  }

  if (!flagOnLocalStorage) {
    return featureToggle[flag] || false
  }

  return flagOnLocalStorage === 'true' ? true : false
}

export const getCountryToStorage = () => {
  let countryPrefix = null;
  if (typeof window !== 'undefined') {
    countryPrefix = localStorage.getItem('countryPrefix')
  }
  if (!countryPrefix) {
    return null;
  }
  return countryPrefix
}